import { render, staticRenderFns } from "./TelegramAuth.vue?vue&type=template&id=46935264&scoped=true&"
import script from "./TelegramAuth.vue?vue&type=script&lang=js&"
export * from "./TelegramAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46935264",
  null
  
)

export default component.exports